import { RefObject, useEffect, useRef, useState } from 'react';

export const useElementWidth = <T extends HTMLElement>(): { elementWidth: number; elementRef: RefObject<T> } => {
  const elementRef = useRef<T>(null);
  const [elementWidth, setElementWidth] = useState<number | undefined>(0);

  useEffect(() => {
    setElementWidth(elementRef?.current?.offsetWidth);
  }, [elementRef]);

  return { elementWidth: elementWidth || 0, elementRef };
};
